import * as React from 'react';
import { observer } from 'mobx-react-lite';

let styles = require('./LiveNotification.scss');

/**
 * Props for LiveNotification component
 */
export interface LiveNotificationProps {
    /**
     * Message to be read by screen readers
     */
    message: string;

    /**
     * Whether all changes to the component should be re-read by screenreaders.
     * True if all changes should be re-read; false otherwise
     */
    atomic: boolean;
}

/**
 * Component to send live notification messages to screenreaders
 */
export const LiveNotification = observer(function LiveNotification(props: LiveNotificationProps) {
    const { message, atomic } = props;

    return (
        <div aria-live={'polite'} aria-atomic={atomic} className={styles.alert}>
            <span>{message}</span>
        </div>
    );
});
